import Input from 'client/core/Input';

export default class LockedCountryField extends Input {
    setValue() {}
}
